/**
 * Gets the current checkout stage.
 * @returns {string} - current stage
 */
function getCurrentStage() {
    var stage = '';
    var pageContext = window.pageContext.ns;
    if (pageContext === 'checkoutlogin' || pageContext === 'checkout') {
        stage = pageContext;
    } else if (!localStorage.getItem('isCartFromTradeIn')) {
        stage = $('#checkout-main').attr('data-checkout-stage');
    }
    return stage;
}

/**
 * Triggers an event to react native app.
 * @param {string} event - event name
 */
function postMessage(event) {
    try {
        if ($('#app-session').val() === 'true') {
            window.ReactNativeWebView.postMessage(event);
        }
    } catch (e) {
        console.log(e);
    }
}

/**
 * Redirects to page based on the customer type.
 */
function redirectBasedOnCustomerType() {
    var customerType = $('#checkout-main').attr('data-customer-type');
    if (customerType === 'registered') {
        var isNewApp = $('#app-session').attr('data-is-new-app') === 'true';
        window.location.href = isNewApp ? '/cart/?noHeader=true' : '/cart/?target=gsnativeapp';
    } else {
        window.location.href = '/checkout/login';
    }
}

module.exports = function () {
    // Back button functionality
    $('#back-button').on('click', function (e) {
        e.preventDefault();
        var pageContext = window.pageContext.ns;
        var navigateTo = $('#go-back').val();
        var isSavedTradeFromApp = $('.savedTradeItemCards').data('direct-navigate-save-trade');
        var isCartFromTardeInPage = localStorage.getItem('isCartFromTradeIn');
        if (window.pageContext.ns === 'Trade' && isSavedTradeFromApp) {
            navigateTo = 'goHomePage';
        }
        if (navigateTo && !isCartFromTardeInPage) {
            if (pageContext === 'cart') {
                $('body').trigger('cart:backButton');
            }
            postMessage(navigateTo);
        } else {
            $.spinner().start();
            var stage = getCurrentStage() || '';
            if (pageContext === 'checkout' || pageContext === 'checkoutlogin' || pageContext === 'checkout') {
                switch (stage) {
                    case 'shipping':
                    case 'checkout':
                        redirectBasedOnCustomerType();
                        break;
                    case 'payment':
                        var skipShipping = $('#checkout-main').attr('data-skip-shipping');
                        if (skipShipping === 'true') {
                            redirectBasedOnCustomerType();
                        } else {
                            window.location.href = '/checkout/?stage=shipping#shipping';
                        }
                        break;
                    case 'placeOrder':
                        window.location.href = '/checkout/?stage=payment#payment';
                        break;
                    case 'checkoutlogin':
                        $('body').trigger('cart:backButton');
                        var isNewApp = $('#app-session').attr('data-is-new-app') === 'true';
                        window.location.href = isNewApp ? '/cart/?noHeader=true' : '/cart/?target=gsnativeapp';
                        break;
                    default:
                        break;
                }
            }
            if (pageContext === 'trade search' || pageContext === 'trade details' || pageContext === 'Trade' || (pageContext === 'cart' && isCartFromTardeInPage)) {
                if (isCartFromTardeInPage) {
                    localStorage.removeItem('isCartFromTradeIn');
                }
                window.history.back();
            }
            $.spinner().stop();
        }
    });

    $('.navigate-to-homepage').on('click', function () {
        postMessage('goLandingPage');
    });
};
